import React from 'react';
import { slate, silver } from '../colors';

var CarouselFallback = function CarouselFallback() {
  return React.createElement("div", {
    className: "item active",
    style: {
      backgroundColor: silver,
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    }
  }, React.createElement("p", {
    className: "text-center",
    style: {
      color: slate,
      marginBottom: 0
    }
  }, "No image available"));
};

export default CarouselFallback;